export const FULFILLMENT_ORDERS_ROUTES = {
  label: '/orders/print-label',
  receipt: '/orders/print-receipt',
  contentDeclaration: '/orders/print-content-declaration',
  prePrintOca: '/orders/pre-config-oca-document',
};
